/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { ConsultationStrictHttpResponse } from '../../consultation-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { EncounterDetailModel } from '../../models/encounter-detail-model';

export interface EncounterFhirIdGet$Params {
  fhirId: string;
}

export function encounterFhirIdGet(http: HttpClient, rootUrl: string, params: EncounterFhirIdGet$Params, context?: HttpContext): Observable<ConsultationStrictHttpResponse<EncounterDetailModel>> {
  const rb = new RequestBuilder(rootUrl, encounterFhirIdGet.PATH, 'get');
  if (params) {
    rb.path('fhirId', params.fhirId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as ConsultationStrictHttpResponse<EncounterDetailModel>;
    })
  );
}

encounterFhirIdGet.PATH = '/Encounter/{fhirId}';
